import axios from '../../axios'

/*
 * 实体数据接口
 */
// 获取实体列表
export const getentityList = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/page',
        method: 'get',
        data
    })
}

// 实体id查询
export const getIdentityList = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/get',
        method: 'get',
        data
    })
}

// 新增实体信息
export const addEntity = (data) => {
    return axios({
        url: '/api/course/tiktok/entity',
        method: 'post',
        data
    })
}

// 编辑实体信息
export const updateEntity = (data) => {
    return axios({
        url: '/api/course/tiktok/entity',
        method: 'put',
        data
    })
}

// 删除实体列表
export const deleteEntity = (data) => {
    return axios({
        url: '/api/course/tiktok/entity',
        method: 'delete',
        data
    })
}

// 实体提审
export const arraignedEntity = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/submit',
        method: 'post',
        data
    })
}

// 实体状态查询
export const statusEntity = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/status',
        method: 'get',
        data
    })
}

// 实体列表查询 传参dataType 1、基础查询，2、审核数据查询
export const getlistentity = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/page',
        method: 'get',
        data
    })
}

// 更新基础认证
export const renewBasiceAttestation = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/basic/auth/update',
        method: 'post',
        data
    })
}
// 更新类别认证
export const renewClassAttestation = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/class/auth/update',
        method: 'post',
        data
    })
}

// 基础认证查询
export const searchBasiceAttestation = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/basic/auth/query',
        method: 'get',
        data
    })
}
// 类别认证查询
export const searchClassAttestation = (data) => {
    return axios({
        url: '/api/course/tiktok/entity/class/auth/query',
        method: 'get',
        data
    })
}

// 审核分页查询
export const getentityauditList = (data) => {
    return axios({
        url: '/api/course/tiktok/audit/page',
        method: 'get',
        data
    })
}
// 审核id查询
export const getentityauditidList = (data) => {
    return axios({
        url: '/api/course/tiktok/audit/get',
        method: 'get',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/tiktok/entiry.js